import { FC } from "react";

import { EventAdvantages } from "@src/interfaces/event.interfaces";

import { Styled } from "./styles";

export const EventFeatureItem: FC<EventAdvantages> = ({ text }) => {
  return <Styled.Feature>{text}</Styled.Feature>;
};
